import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Divider, Drawer, Grid, IconButton, List } from "@material-ui/core";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import MenuItem from "./MenuItem";
import useStyles from "./styles";

const Navigator = ({ navigation, open, onClose, ...other }) => {
  const classes = useStyles();
  return (
    <Drawer
      variant="permanent"
      className={clsx(classes.drawer, {
        [classes.drawerOpen]: open,
        [classes.drawerClose]: !open
      })}
      classes={{
        paper: clsx({
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open
        })
      }}
      {...other}
    >
      <div className={classes.toolbar} />
      <List disablePadding className={classes.menu}>
        {navigation.map(item => (
          <React.Fragment key={item.title}>
            <MenuItem classes={classes} item={item} />
            <Divider />
          </React.Fragment>
        ))}
      </List>
      <List disablePadding>
        <Grid container justify={open ? "flex-end" : "center"}>
          <IconButton onClick={onClose()}>{open ? <ChevronLeftIcon /> : <ChevronRightIcon />}</IconButton>
        </Grid>
      </List>
    </Drawer>
  );
};

Navigator.propTypes = {
  navigation: PropTypes.arrayOf(PropTypes.object).isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired
};

Navigator.defaultProps = {
  open: false
};

export default Navigator;
